/**
 * Guest-booking preview URL derivation (DNKADM-0283). Lives in its own module
 * (not in `GuestBookingPreviewDialog.tsx`) so the dialog file exports only
 * components without tripping react-refresh — the same
 * `PaymentsSettingsIndexRedirect` "non-component export in its own file"
 * precedent (DNKADM-0287 fold-in).
 */
import { env } from '@/config/env';

/** The member app's chromeless embeddable guest funnel (DNKJRX-0198). */
export const EMBED_BOOK_PATH = '/embed/book';

/**
 * The guest-booking preview URL, or `null` when the member origin is not
 * recoverable from this console's host — the caller hides the affordance.
 */
export function guestBookingPreviewUrl(): string | null {
  return env.memberOrigin === null ? null : `${env.memberOrigin}${EMBED_BOOK_PATH}`;
}
